export default {
  retailCategories: [],
  category: {},
  defaultCategory: {},
  categoryColors: [],
}
